export default __webpack_public_path__ + "static/media/young-horz.a09351f1.webp";